module.exports = __webpack_public_path__ + "img/UKR.04d074d8.svg";